<template>
  <div class="general-frame" style="position: fixed;">
    <tow-map :isScreen="false"></tow-map>
  </div>
</template>


<script>
import towMap from "@/components/html/towMap.vue";

export default {
  components: {
    towMap
  },
  data() {
    return {
    };
  },
  methods: {
  },
  mounted() {
  },
};
</script>
<style scoped>
.general-frame >>> .el-dialog__title {
  color: white;
}

.general-frame >>> .el-dialog__body {
  color: white;
}

.general-frame >>> .el-dialog {
  background: #001529bb;
}
</style>



// WEBPACK FOOTER //
// src/pages/menu/toilet/toiletMap.vue